"use client";
import { cn as e } from "../../lib/utils.js";
import { jsx as t } from "react/jsx-runtime";
import { Toaster as n, toast as r } from "sonner";
//#region src/components/Sonner/Sonner.tsx
function i(r) {
	return /* @__PURE__ */ t(n, {
		expand: !0,
		theme: "light",
		className: "toaster group",
		toastOptions: { classNames: {
			toast: e("toast group font-ic-web-body group-[.toaster]:border-ic-web-border group-[.toaster]:bg-ic-web-background group-[.toaster]:text-ic-web-heading group-[.toaster]:shadow-lg"),
			description: "group-[.toast]:text-ic-web-text-muted",
			actionButton: "group-[.toast]:bg-ic-web-heading group-[.toast]:text-ic-web-background",
			cancelButton: "group-[.toast]:bg-ic-web-background-muted group-[.toast]:text-ic-web-text-muted",
			closeButton: "top-1 right-1 left-auto transform-none rounded-sm border-none bg-ic-web-background"
		} },
		...r
	});
}
//#endregion
export { i as Toaster, r as toast };
